/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForesightScenarioFactor = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ForesightScenarioFactor model module.
   * @module model/ForesightScenarioFactor
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ForesightScenarioFactor</code>.
   * @alias module:model/ForesightScenarioFactor
   * @class
   */
  var exports = function() {
    var _this = this;
















  };

  /**
   * Constructs a <code>ForesightScenarioFactor</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ForesightScenarioFactor} obj Optional instance to populate.
   * @return {module:model/ForesightScenarioFactor} The populated <code>ForesightScenarioFactor</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('ElementID')) {
        obj['ElementID'] = ApiClient.convertToType(data['ElementID'], 'Integer');
      }
      if (data.hasOwnProperty('Impact')) {
        obj['Impact'] = ApiClient.convertToType(data['Impact'], 'Number');
      }
      if (data.hasOwnProperty('Relative')) {
        obj['Relative'] = ApiClient.convertToType(data['Relative'], 'Boolean');
      }
      if (data.hasOwnProperty('Smooth')) {
        obj['Smooth'] = ApiClient.convertToType(data['Smooth'], 'Boolean');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('ImpactDate')) {
        obj['ImpactDate'] = ApiClient.convertToType(data['ImpactDate'], 'Date');
      }
      if (data.hasOwnProperty('EndDate')) {
        obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'Date');
      }
      if (data.hasOwnProperty('FinalOnly')) {
        obj['FinalOnly'] = ApiClient.convertToType(data['FinalOnly'], 'Boolean');
      }
      if (data.hasOwnProperty('Enabled')) {
        obj['Enabled'] = ApiClient.convertToType(data['Enabled'], 'Boolean');
      }
      if (data.hasOwnProperty('BreakthroughID')) {
        obj['BreakthroughID'] = ApiClient.convertToType(data['BreakthroughID'], 'Integer');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} ElementID
   * @default 0
   */
  exports.prototype['ElementID'] = 0;
  /**
   * @member {Number} Impact
   * @default 0.0
   */
  exports.prototype['Impact'] = 0.0;
  /**
   * @member {Boolean} Relative
   * @default false
   */
  exports.prototype['Relative'] = false;
  /**
   * @member {Boolean} Smooth
   * @default false
   */
  exports.prototype['Smooth'] = false;
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} ImpactDate
   */
  exports.prototype['ImpactDate'] = undefined;
  /**
   * @member {Date} EndDate
   */
  exports.prototype['EndDate'] = undefined;
  /**
   * @member {Boolean} FinalOnly
   * @default false
   */
  exports.prototype['FinalOnly'] = false;
  /**
   * @member {Boolean} Enabled
   * @default false
   */
  exports.prototype['Enabled'] = false;
  /**
   * @member {Integer} BreakthroughID
   */
  exports.prototype['BreakthroughID'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


